import React from 'react'
import { prop } from 'ramda'

import MultiSelectSearchField from '~/components/Fields/MultiSelectSearchField'
import * as API from '~/constants/api'

const getOptionLabel = item => {
  if (item) {
    return prop('number', item)
  }

  return ''
}

const getOptionValue = item => {
  if (item) {
    const id = prop('toObjectId', item)
    const number = prop('toObjectNumber', item)

    return { id, number }
  }

  return null
}

function PackingItemField (props) {
  return (
    <MultiSelectSearchField
      name="objects"
      label="Orders numbers"
      api={API.PACKING_LIST}
      params={{ limit: 10 }}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      {...props}
    />
  )
}

export default PackingItemField
